(() => {
  const SECTION_SELECTOR = '[data-scroll-color-story-section]';
  const TRACK_SELECTOR = '[data-story-mobile-track]';
  const CARD_SELECTOR = '[data-story-mobile-card]';
  const PREV_SELECTOR = '[data-story-mobile-prev]';
  const NEXT_SELECTOR = '[data-story-mobile-next]';
  const DETAIL_ITEM_SELECTOR = '[data-story-mobile-detail-item]';
  const PROGRESS_SELECTOR = '[data-story-mobile-progress]';
  const PROGRESS_BAR_SELECTOR = '[data-story-mobile-progress-bar]';

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const setupSection = (section) => {
    if (section.dataset.mobileNavBound === 'true') return;
    section.dataset.mobileNavBound = 'true';

    const track = section.querySelector(TRACK_SELECTOR);
    if (!track) return;

    const cards = Array.from(section.querySelectorAll(CARD_SELECTOR));
    if (cards.length < 2) return;

    const prevBtn = section.querySelector(PREV_SELECTOR);
    const nextBtn = section.querySelector(NEXT_SELECTOR);
    const detailItems = Array.from(section.querySelectorAll(DETAIL_ITEM_SELECTOR));
    const progress = section.querySelector(PROGRESS_SELECTOR);
    const progressBar = section.querySelector(PROGRESS_BAR_SELECTOR);

    let currentIndex = 0;

    const getBlockIndex = (index) => {
      const card = cards[index];
      const parsedIndex = Number.parseInt(card ? card.dataset.blockIndex : '0', 10);
      return Number.isNaN(parsedIndex) ? 0 : parsedIndex;
    };

    const updateProgress = (blockIndex) => {
      if (!progress || !progressBar) return;
      const detailCount = Math.max(detailItems.length, 1);
      const maxOffset = Math.max(progress.clientWidth - progressBar.offsetWidth, 0);
      const ratio = detailCount > 1 ? blockIndex / (detailCount - 1) : 0;
      progressBar.style.transform = `translate3d(${maxOffset * ratio}px, 0, 0)`;
    };

    const updateUI = () => {
      const blockIndex = getBlockIndex(currentIndex);

      cards.forEach((card, index) => {
        card.classList.toggle('is-active', index === currentIndex);
      });
      detailItems.forEach((item, index) => {
        item.classList.toggle('is-active', index === blockIndex);
      });
      updateProgress(blockIndex);
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= cards.length - 1;
    };

    const scrollToIndex = (index) => {
      const clamped = Math.max(0, Math.min(cards.length - 1, index));
      const target = cards[clamped];
      if (!target) return;
      const trackStyles = window.getComputedStyle(track);
      const paddingLeft = Number.parseFloat(trackStyles.paddingLeft) || 0;
      const offset = target.offsetLeft - paddingLeft;
      track.scrollTo({ left: offset, behavior: 'smooth' });
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollToIndex(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollToIndex(currentIndex + 1);
      });
    }

    let scrollRaf = null;
    const detectActive = () => {
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let bestIndex = 0;
      let bestDistance = Infinity;
      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCenter - trackCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });
      if (bestIndex !== currentIndex) {
        currentIndex = bestIndex;
        updateUI();
      }
    };

    track.addEventListener(
      'scroll',
      () => {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(() => {
          scrollRaf = null;
          detectActive();
        });
      },
      { passive: true }
    );

    const handleViewportChange = () => {
      if (!mobileQuery.matches) {
        track.scrollLeft = 0;
        currentIndex = 0;
        updateUI();
      } else {
        detectActive();
      }
    };

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleViewportChange);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(handleViewportChange);
    }

    updateUI();
  };

  const init = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(setupSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector(SECTION_SELECTOR);
      if (section) {
        section.dataset.mobileNavBound = '';
        setupSection(section);
      }
    });
  }
})();
